module.exports = __webpack_public_path__ + "7da0dec3e84738efef26e83e2b933b1d.svg";